import type { ReactNode } from "react";
import { Columns } from "@fullscript/aviary-web";
import * as styles from "./DocsLayout.styles";

type Props = {
  leftContent: ReactNode;
  rightContent: ReactNode;
  children: ReactNode;
  footer: ReactNode;
};

const DocsLayout = ({ leftContent, rightContent, children, footer }: Props) => {
  return (
    <Columns customCss={styles.layout} isMarginless>
      <Columns.Column columnWidth={3} customCss={styles.stickyColumn}>
        {leftContent}
      </Columns.Column>
      <Columns.Column columnWidth={6} customCss={styles.mainColumn}>
        {children}
        {footer}
      </Columns.Column>
      <Columns.Column columnWidth={3} customCss={styles.stickyColumn}>
        {rightContent}
      </Columns.Column>
    </Columns>
  );
};

export { DocsLayout };
